import { BaseEvent } from '../base-event';
import { ErrorMessages } from '../../consts';
import { MAX_EXT_ATTRIBUTES } from '../consts';
import { flattenObject } from '@sitecore-cloudsdk/utils';
export class CustomEvent extends BaseEvent {
    /**
     * A class that extends from {@link BaseEvent} and has all the required functionality to send a VIEW event
     * @param args - Unified object containing the required properties
     */
    constructor(args) {
        const { channel, currency, language, page, type, extensionData, searchData, ...rest } = args.eventData;
        super({ channel, currency, language, page }, args.id);
        this.extensionData = {};
        this.sendEvent = args.sendEvent;
        this.settings = args.settings;
        this.customEventPayload = {
            type,
            ...rest
        };
        if (extensionData)
            this.extensionData = flattenObject({ object: extensionData });
        const numberOfExtensionDataProperties = Object.entries(this.extensionData).length;
        if (numberOfExtensionDataProperties > MAX_EXT_ATTRIBUTES)
            throw new Error(ErrorMessages.IV_0005);
        if (numberOfExtensionDataProperties > 0)
            this.customEventPayload.ext = this.extensionData;
        if (searchData)
            this.customEventPayload.sc_search = {
                data: searchData,
                metadata: {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    ut_api_version: '1.0'
                }
            };
    }
    /**
     * Sends the event to Sitecore EP
     * @returns - A promise that resolves with either the Sitecore EP response object or null
     */
    async send() {
        const baseAttr = this.mapBaseEventPayload();
        const fetchBody = Object.assign({}, this.customEventPayload, baseAttr);
        return await this.sendEvent(fetchBody, this.settings);
    }
}
